// Observes window.dataLayer for diagnostics without altering GTM behavior.
// Mirrors the singleton + listener-Set shape of feature-flag-usage-store.js.

const MAX_EVENTS = 10;

const events = [];
const listeners = new Set();

let snapshot = Object.freeze([]);
let initialized = false;

const computeSnapshot = () => Object.freeze(events.map((entry) => Object.freeze({ ...entry })));

const notify = () => {
   snapshot = computeSnapshot();
   listeners.forEach((listener) => listener());
};

const recordEntry = (entry) => {
   if (!entry || typeof entry !== 'object' || typeof entry.event !== 'string') return;

   events.unshift({ event: entry.event, timestamp: Date.now(), payload: entry });
   events.length = Math.min(events.length, MAX_EVENTS);
   notify();
};

export const initDataLayerDiagnostics = () => {
   if (initialized || typeof window === 'undefined') return;
   initialized = true;

   window.dataLayer = window.dataLayer || [];

   window.dataLayer.forEach(recordEntry);

   const nativePush = window.dataLayer.push.bind(window.dataLayer);
   window.dataLayer.push = (...args) => {
      const result = nativePush(...args);
      args.forEach(recordEntry);
      return result;
   };
};

export const subscribeToDataLayerEvents = (listener) => {
   listeners.add(listener);
   return () => listeners.delete(listener);
};

export const getDataLayerEventsSnapshot = () => snapshot;
